/**
 * MotivoCambioHost — el cuadro que pregunta «¿Qué hay que cambiar?» cuando una pieza vuelve con cambios (ver src/lib/motivoCambio.js).
 * Un solo cuadro para toda la app. El texto es obligatorio (mínimo 8 caracteres): queda en el historial, en el hilo de la pieza y en el aviso al diseñador.
 */
import { useEffect, useRef, useState } from "react";
import { registrarHost } from "../lib/motivoCambio.js";

const PISTA = {
  "Cliente Cambios": "Pegá lo que pidió el cliente, con sus palabras. Si vino por WhatsApp o en una llamada, copialo acá para que el diseñador no tenga que adivinar.",
  "EC Cambios": "Qué hay que corregir antes de mandarla al cliente.",
  "QC Cambios": "Qué no pasó el control de calidad y cómo se arregla.",
};

export default function MotivoCambioHost() {
  const [pedido, setPedido] = useState(null);
  const [texto, setTexto] = useState("");
  const ta = useRef(null);

  useEffect(() => {
    registrarHost(true);
    const f = (e) => { setTexto(""); setPedido(e.detail); };
    window.addEventListener("crew-pedir-motivo", f);
    return () => { window.removeEventListener("crew-pedir-motivo", f); registrarHost(false); };
  }, []);
  useEffect(() => { if (pedido) requestAnimationFrame(() => ta.current?.focus()); }, [pedido]);
  if (!pedido) return null;

  const cerrar = (valor) => { pedido.resolver(valor); setPedido(null); };
  const ok = texto.trim().length >= 8;
  const retroceso = !!pedido.retroceso;
  return (
    <div className="fixed inset-0 z-[80] grid place-items-end bg-black/40 sm:place-items-center" role="dialog" aria-modal="true" aria-label="Qué hay que cambiar" onKeyDown={(e) => { if (e.key === "Escape") cerrar(null); }}>
      <div className="w-full max-w-lg rounded-t-3xl bg-card p-5 shadow-xl sm:rounded-3xl">
        <h2 className="text-[18px] font-extrabold">{retroceso ? "Esta pieza ya la ve el cliente" : "¿Qué hay que cambiar?"}</h2>
        <p className="mt-0.5 text-[13.5px] text-muted-foreground">{retroceso
          ? <>Si la pasás a <b className="text-foreground">EC Aprobado</b> se la retirás: <b className="text-foreground">deja de poder revisarla</b> y la ve «en proceso» hasta que la vuelvas a enviar. Escribí por qué la retirás.</>
          : <>La pieza pasa a <b className="text-foreground">{pedido.estado}</b>. {PISTA[pedido.estado] || ""}</>}</p>
        <textarea ref={ta} value={texto} onChange={(e) => setTexto(e.target.value)} rows={5} maxLength={1200} aria-label="Qué hay que cambiar"
          placeholder={retroceso ? "Ej.: Se mandó la versión equivocada; hay que corregir el logo antes de que la vea." : "Ej.: Cambiar el fondo a crema, agrandar el logo y corregir la fecha del evento (es el 14, no el 15)."}
          className="mt-3 w-full resize-none rounded-2xl border border-input bg-background p-3 text-[15px] leading-snug outline-none focus-visible:ring-2 focus-visible:ring-ring/60 max-md:text-[16px]" />
        <div className="mt-1 flex items-center justify-between text-[12px] text-muted-foreground"><span>{ok ? "" : "Escribí al menos una frase corta."}</span><span className="tabular-nums">{texto.length}/1200</span></div>
        <div className="mt-3 flex justify-end gap-2">
          <button type="button" onClick={() => cerrar(null)} className="h-11 rounded-full px-5 text-[14px] font-bold text-muted-foreground hover:bg-muted">Cancelar</button>
          <button type="button" disabled={!ok} onClick={() => cerrar(texto.trim())} className="h-11 rounded-full bg-foreground px-6 text-[14px] font-extrabold text-background disabled:opacity-40">{retroceso ? "Retirar del cliente" : <>Pasar a {pedido.estado}</>}</button>
        </div>
      </div>
    </div>
  );
}
